import { useSelector } from 'react-redux';
import { TempRoute, selectItems } from './routesTable.slice';

export const useTempRoutes = (): TempRoute[] => {
  return useSelector(selectItems);
};
